import React from 'react';
import { Modal, Button, Group } from '@mantine/core';
import { DateFormatter, DatePickerInput } from '@mantine/dates';
import { t } from 'i18next';
import dayjs from 'dayjs';

interface CustomDateModalProps {
  opened: boolean;
  onClose: () => void;
  dateRange: [Date | null, Date | null];
  onDateChange: (range: [Date | null, Date | null]) => void;
}

const formatter: DateFormatter = ({ type, date, locale, format }) => {
  console.log(format);
  if (type === 'range' && Array.isArray(date)) {
    if (date[0] !== null && date[1] === null) 
      return`${dayjs(date[0]).locale(locale).format(format)} - `;

    if (date[0] !== null && date[1] !== null) 
      return`${dayjs(date[0]).locale(locale).format(format)} - ${dayjs(date[1]).locale(locale).format(format)}`;
    
  }

  return t('graph.startEndDates');
};

export const CustomDateModal: React.FC<CustomDateModalProps> = ({
  opened,
  onClose,
  dateRange,
  onDateChange,
}) => {
  // Local state to track the date range before confirming
  const [tempDateRange, setTempDateRange] = React.useState<[Date | null, Date | null]>(dateRange);

  // Reset temp date range when modal opens
  React.useEffect(() => {
    if (opened) 
      setTempDateRange(dateRange);
    
  }, [opened, dateRange]);

  const handleConfirm = () => {
    // Only apply dates if both start and end dates are selected
    if (tempDateRange[0] && tempDateRange[1]) {
      onDateChange(tempDateRange);
      onClose();
    }
  };

  const handleCancel = () => {
    setTempDateRange(dateRange);
    onClose();
  };

  return (
    <Modal 
      opened={opened} 
      onClose={onClose}
      title={t('graph.selectCustomDateRange')}
      size="md"
    >
      <DatePickerInput
        type="range"
        label={t('graph.selectDateRange')}
        placeholder={t('graph.startEndDates')}
        value={tempDateRange}
        onChange={setTempDateRange}
        clearable
        maxDate={new Date()}
        mb="md"
        valueFormatter={formatter}
        valueFormat="YYYY-MM-DD"
      />
      
      <Group justify="flex-end" mt="md">
        <Button variant="outline" onClick={handleCancel}>
          {t('common.cancel')}
        </Button>
        <Button 
          onClick={handleConfirm}
          disabled={!tempDateRange[0] || !tempDateRange[1]}
        >
          {t('common.apply')}
        </Button>
      </Group>
    </Modal>
  );
}; 